<template>
    <h1 class="sr-only">Quiz Results</h1>
    <h2 class="mb-4 text-pretty text-white md:mb-12 md:text-lg xl:text-xl">
        Let’s see the real numbers (measured in CO<sub>2</sub>e):
    </h2>
    <section class="md:hidden">
        <Swiper
            :slides-per-view="1"
            :centered-slides="true"
            :effect="'cards'"
            :modules="modules"
            class="max-w-sm"
        >
            <SwiperSlide v-for="q in questions" :key="q.questionId">
                <ResultsCard
                    :image="q.scoreImage?.url"
                    :correct="isCorrect(q.questionId)"
                    :correct-value="q.correctValue"
                />
            </SwiperSlide>
        </Swiper>
    </section>
    <section
        class="mx-auto hidden max-w-4xl grid-cols-8 gap-4 md:grid md:gap-x-12 md:gap-y-8"
    >
        <div class="col-span-2" v-for="q in firstRow" :key="q.questionId">
            <ResultsCard
                :image="q.scoreImage?.url"
                :correct-value="q.correctValue"
                :correct="isCorrect(q.questionId)"
            />
        </div>
        <div
            class="col-span-2"
            v-for="(q, i) in secondRow"
            :key="q.questionId"
            :class="i === 0 ? 'col-start-2' : 'col-start-auto'"
        >
            <ResultsCard
                :image="q.scoreImage?.url"
                :correct-value="q.correctValue"
                :correct="isCorrect(q.questionId)"
            />
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useQuizStore } from "../stores/quizStore";
import { EffectCards } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/effect-cards";
import ResultsCard from "./ResultsCard.vue";

const quiz = useQuizStore();

const questions = computed(() => quiz.questions);

const firstRow = computed(() => questions.value.slice(0, 4));
const secondRow = computed(() => questions.value.slice(4, 7));

function isCorrect(questionId: string) {
    return quiz.getAnswer(questionId)?.isCorrect === true;
}

const modules = [EffectCards];
</script>
